import React, { useEffect, useState } from "react";
import { Button, DatePicker, Select, Row, Col, Typography } from "antd";
import dayjs from "dayjs";
import useUserData from "../hooks/useUserData";

const { RangePicker } = DatePicker;
const { Option } = Select;
const { Title } = Typography;

const GenerateReportToolstaff = ({
  selectedDates,
  setSelectedDates,
  voyage,
  setVoyage,
  selectedReport,
  setselectedReport,
  setStartDates,
  setEndDates,
  filteredData,
  generatePdf,
}) => {
  const user = useUserData();
  const [parameterOptions, setParameterOptions] = useState([]);

  const dateRanges = [
    {
      label: "Last 2 Days",
      value: () => [dayjs().subtract(2, "days"), dayjs()],
    },
    {
      label: "Last 1 Week",
      value: () => [dayjs().subtract(1, "weeks"), dayjs()],
    },
    {
      label: "Last 1 Month",
      value: () => [dayjs().subtract(1, "months"), dayjs()],
    },
    {
      label: "Last 3 Month",
      value: () => [dayjs().subtract(3, "months"), dayjs()],
    },
  ];

  // update start & end dates whenever selectedDates changes
  if (selectedDates && selectedDates.length === 2) {
    const startDates = dayjs(selectedDates[0]).format("YYYY-MM-DD");
    const endDates = dayjs(selectedDates[1]).format("YYYY-MM-DD");
    setStartDates(startDates);
    setEndDates(endDates);
  }

  const parameterMappings = [
    { value: "orb-part-1", label: "ORB Part 1" },
    { value: "orb-part-2", label: "ORB Part 2" },
    {
      value: "garbage-record-book-part-1",
      label: "Garbage Record Book Part 1",
    },
    {
      value: "garbage-record-book-part-2",
      label: "Garbage Record Book Part 2",
    },
    { value: "ballast-water-record-book", label: "Ballast Water Record Book" },
    { value: "consumption-log", label: "Consumption Log" },
    { value: "sounding-log", label: "Sounding Log" },
  ];

  useEffect(() => {
    setParameterOptions(parameterMappings || []);
    setselectedReport("orb-part-1");
  }, []);

  useEffect(() => {
    if (filteredData?.length > 0) {
      const runningVoyage = filteredData.find(
        (voyage) => voyage?.voyage_status === true
      );
      if (runningVoyage) {
        // setVoyage(runningVoyage.id);
      }
    }
  }, [filteredData]);

  const handleDateChange = (dates) => setSelectedDates(dates);
  const handleVoyageChange = (value) => setVoyage(value);
  const handleParameterChange = (values) => setselectedReport(values);

  return (
    <div style={{ padding: 16 }}>
      <Row gutter={[16, 16]}>
        {/* Select Voyage */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <div className="selector-label">Select Voyage</div>
          <Select
            placeholder="---- Select Voyage Id ----"
            style={{ width: "100%" }}
            value={voyage}
            onChange={handleVoyageChange}
          >
            {filteredData?.map((voy) => (
              <Option key={voy.id} value={voy.id}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span>{`Voyage Id: ${voy.id}`}</span>
                  <span
                    style={{
                      color: voy.voyage_status ? "#FFA500" : "#008000",
                      fontWeight: 550,
                    }}
                  >
                    {voy.voyage_status ? "Running" : "Complete"}
                  </span>
                </div>
              </Option>
            ))}
          </Select>
        </Col>

        {/* Select Log Report */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <div className="selector-label">Select Log Report</div>
          <Select
            showSearch
            placeholder="Select Log Report"
            onChange={handleParameterChange}
            value={selectedReport || undefined}
            style={{ width: "100%" }}
            filterOption={(input, option) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
          >
            {parameterOptions.map((engine) => (
              <Option key={engine.value} value={engine.value}>
                {engine.label}
              </Option>
            ))}
          </Select>
        </Col>

        {/* Select Date Range */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <div className="selector-label">Select Date Range</div>
          <RangePicker
            presets={dateRanges}
            onChange={handleDateChange}
            value={
              selectedDates?.length
                ? [dayjs(selectedDates[0]), dayjs(selectedDates[1])]
                : undefined
            }
            format="YYYY-MM-DD"
            style={{ width: "100%" }}
            disabledDate={(current) =>
              current && current > dayjs().endOf("day")
            }
          />
        </Col>

        {/* Generate Report Button */}
        <Col
          xs={24}
          sm={12}
          md={8}
          lg={6}
          style={{ display: "flex", alignItems: "flex-end" }}
        >
          <Button
            block
            type="primary"
            className="generate-btn"
            onClick={generatePdf}
          >
            Generate Report
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default GenerateReportToolstaff;
